import { render } from "./sliderFilterIcon.vue?vue&type=template&id=a1276638"
import script from "./sliderFilterIcon.vue?vue&type=script&lang=js"
export * from "./sliderFilterIcon.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Merlin.Website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__